import { render, staticRenderFns } from "./UserAmount.vue?vue&type=template&id=c3be38c4&scoped=true&"
import script from "./UserAmount.vue?vue&type=script&lang=js&"
export * from "./UserAmount.vue?vue&type=script&lang=js&"
import style0 from "./UserAmount.vue?vue&type=style&index=0&id=c3be38c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3be38c4",
  null
  
)

export default component.exports